import { render } from "./locationDetailsComponent.vue?vue&type=template&id=67530f17"
import script from "./locationDetailsComponent.vue?vue&type=script&lang=js"
export * from "./locationDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__